import * as React from 'react';

const STEP1 = {
  target: '[data-tour="declarations_section"]',
  content: (
    <p>
      Раздел, в котором можно подать декларацию 3-НДФЛ или заявление на зачет или возврат после
      декларации, а также посмотреть статус камеральной налоговой проверки по ранее поданным
      декларациям
    </p>
  ),
  hideCloseButton: true,
  disableBeacon: true,
};
const STEP2 = {
  target: '[data-tour="deductions_section"]',
  content: (
    <p>
      Раздел, в котором отображаются сведения, полученные от налоговых агентов (банков) для
      получения вычетов по НДФЛ без необходимости подачи декларации 3-НДФЛ и подтверждающих
      документов, а также статус проверки ранее поданного заявления на получение вычетов в
      упрощенном порядке
    </p>
  ),
  hideCloseButton: true,
  disableBeacon: true,
};
const STEP3 = {
  target: '[data-tour="incomes_section"]',
  content: (
    <li>
      В данном разделе отображаются:
      <ul>
        • Cправки о доходах и суммах налога физических лиц от работодателя или иного налогового
        агента (с возможностью ее скачивания в формате PDF и электронной подписью ФНС России);
      </ul>
      <ul>• Справки о доходах физических лиц из деклараций на прибыль организации;</ul>
      <ul>• Сведения из расчетов по страховым взносам, предоставленных работодателем;</ul>
    </li>
  ),
  hideCloseButton: true,
  disableBeacon: true,
};

const STEPS_MY_INCOMES_AND_TAXDEDUCTIONS = [STEP1, STEP2, STEP3];
export default STEPS_MY_INCOMES_AND_TAXDEDUCTIONS;
